/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Step_2Inputs */

const en_svc_integration_step_2 = /** @type {(inputs: Svc_Integration_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the model and provider that fit the task, the cost and your data rules.`)
};

const lv_svc_integration_step_2 = /** @type {(inputs: Svc_Integration_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izvēlamies modeli un pakalpojumu sniedzēju, kas atbilst uzdevumam, izmaksām un Jūsu datu noteikumiem.`)
};

/**
* | output |
* | --- |
* | "Pick the model and provider that fit the task, the cost and your data rules." |
*
* @param {Svc_Integration_Step_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_step_2 = /** @type {((inputs?: Svc_Integration_Step_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Step_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_step_2(inputs)
	return en_svc_integration_step_2(inputs)
});